import * as fe from "@runn/filter-engine"
import React from "react"

import FilterBlockBoolean from "./common/FilterBlockBoolean"
import { PalmTree as Icon } from "~/common/react-icons"

type Props = {
  path: number[]
  filter: fe.filters.AnyFilter
  onRemove: (path: number[]) => void
}

const UnknownFilter = (props: Props) => {
  const { filter, path, onRemove } = props

  const handleRemove = () => onRemove(path)

  return (
    <FilterBlockBoolean
      label={filter.type}
      icon={<Icon />}
      onRemove={handleRemove}
    />
  )
}

export default UnknownFilter
